import {InjectionToken} from '@angular/core';

export interface ConfigInterface {

  getEnv(): string;

  tykBaseDomain(path?: string): string;

  tykBaseUrl(path: string, key?: string, service?: string): string;

  tykCaptchaUrl(path: string): string;

  cdnUrl(): string;

  wxOaAppId(): string;

  wxOaAuth(): string;
    
  getWebMainUrl(language): string;

  getAppDownLoadPage(language): string;
  
  inspireFontUrl(): string;

  getWxJs(): string;

  getBubblePage(): string;
}

class LocalConfig implements ConfigInterface {

  getEnv() {
    return 'latest';
  }

  tykBaseDomain(path) { 
    return path;
  }

  tykBaseUrl(path) { 
    return path;
  }

  tykCaptchaUrl(path) { 
    return path;
  }

  cdnUrl() {
    return 'https://static-le.shanghaidisneyresort.com/latest'
  }

  wxOaAppId() { 
    return 'wx79305cc4722052ce';
  }

  wxOaAuth() { 
    return 'https://latest.wechat.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://latest.www.shanghaidisneyresort.com/${lan}`;
  }

  getAppDownLoadPage(lan) {
    return `https://latest.www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static-le.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static-le.shanghaidisneyresort.com/latest/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static-le.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

class DdpConfig implements ConfigInterface {

  getEnv() {
    return 'latest';
  }

  tykBaseDomain() { 
    return 'https://ddp.apigw.shanghaidisneyresort.com';
  }

  tykBaseUrl(path, key:string = 'cu', service: string = 'profile-service') { 
    return `https://ddp.apigw.shanghaidisneyresort.com/${service}${path}`;
  }

  tykCaptchaUrl(path) { 
    return `https://latest-cu.apigw.shanghaidisneyresort.com/captcha-service${path}`;
  }

  cdnUrl() {
    return 'https://static-le.shanghaidisneyresort.com/latest'
  }

  wxOaAppId() { 
    return 'wx79305cc4722052ce';
  }

  wxOaAuth() { 
    return 'https://d1.wechat.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://latest.www.shanghaidisneyresort.com/${lan}`
  }

  getAppDownLoadPage(lan) {
    return `https://latest.www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static-le.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static-le.shanghaidisneyresort.com/latest/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static-le.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

class LatestConfig implements ConfigInterface {

  getEnv() {
    return 'latest';
  }

  tykBaseDomain() { 
    return 'https://latest-cu.apigw.shanghaidisneyresort.com';
  }

  tykBaseUrl(path, key: string = 'cu', service: string = 'profile-service' ) { 
    return `https://latest-${key}.apigw.shanghaidisneyresort.com/${service}${path}`;
  }

  tykCaptchaUrl(path) { 
    return `https://latest-cu.apigw.shanghaidisneyresort.com/captcha-service${path}`;
  }

  cdnUrl() {
    return 'https://static-le.shanghaidisneyresort.com/latest'
  }

  wxOaAppId() { 
    return 'wx79305cc4722052ce';
  }

  wxOaAuth() { 
    return 'https://latest.wechat.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://latest.www.shanghaidisneyresort.com/${lan}`
  }

  getAppDownLoadPage(lan) {
    return `https://latest.www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static-le.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static-le.shanghaidisneyresort.com/latest/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static-le.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

class StageConfig implements ConfigInterface {

  getEnv() {
    return 'stage';
  }

  tykBaseDomain() { 
    return 'https://stage-cu.apigw.shanghaidisneyresort.com';
  }

  tykBaseUrl(path, key: string = 'cu', service: string = 'profile-service' ) { 
    return `https://stage-${key}.apigw.shanghaidisneyresort.com/${service}${path}`;
  }

  tykCaptchaUrl(path) { 
    return `https://stage-cu.apigw.shanghaidisneyresort.com/captcha-service${path}`;
  }

  cdnUrl() {
    return 'https://static-le.shanghaidisneyresort.com/stage'
  }

  wxOaAppId() { 
    return 'wx79305cc4722052ce';
  }

  wxOaAuth() { 
    return 'https://stage.wechat.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://stage.www.shanghaidisneyresort.com/${lan}`
  }

  getAppDownLoadPage(lan) {
    return `https://stage.www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static-le.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static-le.shanghaidisneyresort.com/stage/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static-le.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

class LTConfig implements ConfigInterface {

  getEnv() {
    return 'lt';
  }

  tykBaseDomain() { 
    return 'https://lt01-cu.apigw.shanghaidisneyresort.com';
  }

  tykBaseUrl(path, key: string = 'cu', service: string = 'profile-service' ) { 
    return `https://lt01-${key}.apigw.shanghaidisneyresort.com/${service}${path}`;
  }

  tykCaptchaUrl(path) { 
    return `https://lt01-cu.apigw.shanghaidisneyresort.com/captcha-service${path}`;
  }

  cdnUrl() {
    return 'https://static-le.shanghaidisneyresort.com/lt01'
  }

  wxOaAppId() { 
    return 'wx79305cc4722052ce';
  }

  wxOaAuth() { 
    return 'https://lt01.wechat.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://lt01.www.shanghaidisneyresort.com/${lan}`
  }

  getAppDownLoadPage(lan) {
    return `https://lt01.www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static-le.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static-le.shanghaidisneyresort.com/lt01/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static-le.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

class SLConfig implements ConfigInterface {

  getEnv() {
    return 'sl';
  }

  tykBaseDomain() { 
    return 'https://sl-cu.apigw.shanghaidisneyresort.com';
  }

  tykBaseUrl(path, key: string = 'cu', service: string = 'profile-service') { 
    return `https://sl-${key}.apigw.shanghaidisneyresort.com/${service}${path}`;
  }

  tykCaptchaUrl(path) { 
    return `https://sl-cu.apigw.shanghaidisneyresort.com/captcha-service${path}`;
  }

  cdnUrl() {
    return 'https://static.shanghaidisneyresort.com'
  }

  wxOaAppId() { 
    return 'wx6ad47dff1df440a4';
  }

  wxOaAuth() { 
    return 'https://sl.www.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://sl.www.shanghaidisneyresort.com/${lan}`
  }

  getAppDownLoadPage(lan) {
    return `https://sl.www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static.shanghaidisneyresort.com/sl/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

class PrdConfig implements ConfigInterface {

  getEnv() {
    return 'prd';
  }

  tykBaseDomain() { 
    return 'https://cu.apigw.shanghaidisneyresort.com';
  }

  tykBaseUrl(path, key: string = 'cu', service: string = 'profile-service' ) { 
    return `https://${key}.apigw.shanghaidisneyresort.com/${service}${path}`;
  }

  tykCaptchaUrl(path) { 
    return `https://cu.apigw.shanghaidisneyresort.com/captcha-service${path}`;
  }

  cdnUrl() {
    return 'https://static.shanghaidisneyresort.com'
  }

  wxOaAppId() { 
    return 'wxc1f8364dda6947b5';
  }

  wxOaAuth() { 
    return 'https://www.shanghaidisneyresort.com/wechat-oa-auth-callback';
  }

  getWebMainUrl(lan) {
    return `https://www.shanghaidisneyresort.com/${lan}`
  }

  getAppDownLoadPage(lan) {
    return `https://www.shanghaidisneyresort.com/${lan}/information/download-shanghai-disney-mobile-app/`;
  }

  inspireFontUrl() { 
    return 'https://static.shanghaidisneyresort.com/pep/media/pep/live/media/site/font/InspireTWDC_Web/fonts.css'
  }

  getWxJs() { 
    return 'https://static.shanghaidisneyresort.com/profile-web-ui/assets/jweixin.js';
  }

  getBubblePage() {
    return 'https://static.shanghaidisneyresort.com/common/error-pages/crowding.html';
  }
}

export const CONFIG_OPTIONS = new InjectionToken<ConfigInterface>('config');

const configOptionsFactory = () => {
  let host = window.location.host;
  if (host.startsWith('latest') ){ 
    return new LatestConfig();
  } if (host.startsWith('d1')) {
    return new LatestConfig();
    // return new DdpConfig(); //todo: open ddp env
  } if (host.startsWith('stage')) {
    return new StageConfig();
  } else if (host.startsWith('lt')) {
    return new LTConfig();
  } else if (host.startsWith('sl')) {
    return new SLConfig();
  } else if (host.startsWith('www') || host.startsWith('central') || host.startsWith('wechat')) {
    return new PrdConfig();
  } else { 
    return new LocalConfig();
  }
};

export const configOptionsProvider = {
  provide: CONFIG_OPTIONS,
  useFactory: configOptionsFactory,
};